//*****************************************************************************
// Remove p tags from images and/or iframes
//*****************************************************************************

jQuery(document).ready(function($) {
    // Unwrap images
    //$('p img').unwrap();
    $('p > img').unwrap();

     // Unwrap images and iframes
    //$('p img, p .fluid-width-video-wrapper').unwrap();

});




// Animation On Scroll Global Settings
// https://github.com/michalsnik/aos
AOS.init({
	startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
	mirror: true, // whether elements should animate out while scrolling past them
	//offset: 100,
	//duration: 600,
	//easing: 'ease-in-sine',
	//delay: 300,

});





